<template>
  <div class="home">
    <div class="head">
      <img class="logo" src="../static/images/logo.png" alt />
      <div class="introduce">
        <div class="title">直播魔盒，引领直播新模式</div>
        <div
          class="particulars"
        >直播魔盒是针对现在热门的移动直播而打造的一款直播辅助产品。用户可以通过软件实现替换直播背景，进行网络直播、短视频制作。直播魔盒致力于为广大直播用户实现轻松打造高端直播间，解决用户痛点。</div>
      </div>
    </div>
    <div class="body">
      <img class="left" src="../static/images/left.png" alt />
      <img class="right" src="../static/images/right.png" alt />
      <div class="location" @click="handleInstall">
        <img class="install" src="../static/images/install.png" alt />
        <div>软件下载</div>
      </div>
      <div class="contact" @click="handleContact">
        <img class="relation" src="../static/images/relation.png" alt />
        <div>联系我们</div>
      </div>
      <div class="throng">
        <img class="fit" src="../static/images/fit.png" alt />
        <div class="row">
          <div class="items">
            <img class="crowd" src="../static/images/crowd1.png" alt />
            <div class="written">知识类主播</div>
          </div>
          <div class="items">
            <img class="crowd" src="../static/images/crowd2.png" alt />
            <div class="written">带货主播</div>
          </div>
          <div class="items">
            <img class="crowd" src="../static/images/crowd3.png" alt />
            <div class="written">娱乐类主播</div>
          </div>
          <div class="items">
            <img class="crowd" src="../static/images/crowd4.png" alt />
            <div class="written">短视频创作者</div>
          </div>
        </div>
      </div>
      <div class="commodity">
        <img class="product" src="../static/images/product.png" alt />
        <div class="content">
          <video
            class="content-left"
            :autoplay="true"
            :controls="true"
            src="../static/images/meimei.mp4"
          ></video>
          <div class="content-right">
            <div class="select">
              <div
                class="every"
                @click="handleSwitch(index)"
                v-on:mouseover="changeActive(index)"
                :class="checkVal=== index?'active': ''"
                v-for="(item,index) in checkList"
                :key="index"
              >{{item}}</div>
            </div>
            <div class="option" v-if="checkVal===0">
              <div class="introduce">
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />
                  采用业界顶级抠图方案、发丝级抠图精度，色彩更自然
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />自动识别背景绿幕，能实时背景绿幕替换为自己的图片视频。
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />不需要繁琐的视频绿幕特效软件即可完成好莱坞大神的高端操作。
                </div>
              </div>
              <img class="green" src="../static/images/green-screen.png" alt />
            </div>
            <div class="option" v-if="checkVal===1">
              <div class="introduce">
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />业界领先无绿幕抠图，简单方便操作、只需一台手机无需其他设备即可替换背景。
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />实时捕捉人像轮廓，智能替换掉背景部分，不需要额外设备。也可以完成抠图换背景，让用户们零门槛玩转直播、短视频
                </div>
              </div>
              <img class="green" src="../static/images/ai.png" alt />
            </div>
            <div class="option" v-if="checkVal===2">
              <div class="introduce">
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />可以自由替换场景来满足直播、短视频拍摄等不同应用场景。
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />APP内更有海量精品背景图片、视频素材供用户使用。
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />APP更支持用户自定义背景图片视频，让用户更加自由、玩法更丰富。
                </div>
              </div>
              <img class="green" src="../static/images/replace.png" alt />
            </div>
            <div class="option" v-if="checkVal===3">
              <div class="interaction">
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />互动娱乐: 在直播、短视频等场景，通过实时更换背景来丰富趣味性、专业度，有效增加用户的粘性。
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />直播带货: 在直播带货时，将背景替换为产品图片、视频。让客户的注意力更加容易集中到产品中。轻松提高直播销量！
                </div>
                <div class="each">
                  <img class="check" src="../static/images/check.png" alt />知识类传播: 把背景替换为教程图片，把背景当黑板用！达到沉浸式教育体验，产生身临其境的效果。
                </div>
              </div>
              <img class="range" src="../static/images/range.png" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="superiority">
        <img class="advantage" src="../static/images/advantage.png" alt />
        <div class="row">
          <div class="items">
            <img class="operation" src="../static/images/operation1.png" alt />
            <div class="written">操作简单</div>
            <div class="explain">手指轻轻一滑即可完成切换背景等操作。更搭配有蓝牙键盘、控制器等多种操作</div>
          </div>
          <div class="items">
            <img class="operation" src="../static/images/operation2.png" alt />
            <div class="written">海量精品素材</div>
            <div class="explain">手指轻轻一滑即可完成切换背景等操作。更搭配有蓝牙键盘、控制器等多种操作</div>
          </div>
          <div class="items">
            <img class="operation" src="../static/images/operation3.png" alt />
            <div class="written">业界顶尖技术</div>
            <div class="explain">手指轻轻一滑即可完成切换背景等操作。更搭配有蓝牙键盘、控制器等多种操作</div>
          </div>
          <div class="items">
            <img class="operation" src="../static/images/operation4.png" alt />
            <div class="written">专业售后培训</div>
            <div class="explain">手指轻轻一滑即可完成切换背景等操作。更搭配有蓝牙键盘、控制器等多种操作</div>
          </div>
        </div>
      </div>
      <div class="download" id="download" >
        <img class="img" src="../static/images/download.png" alt />
        <div class="box">
          <div class="each">
            <div class="function" @click="handleAndroid">
              <img class="Android" src="../static/images/Android.png" alt />
              安卓版下载
            </div>
            <div class="info">
              <div class="date">{{version}}版本</div>
              <div class="date">最后更新日期：{{updateDate}}</div>
            </div>
          </div>
          <div class="each">
            <a
              href="http://itunes.apple.com/cn/app/id1574653230?mt=8"
              target="blank"
              class="function function-ios"
            >
              <img class="ios" src="../static/images/ios.png" alt />
              ios版下载
            </a>
            <div class="info">
              <div class="date">2.0.0版本</div>
              <div>最后更新日期：2021/09/17</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" id="footer" >
      <img class="contact" src="../static/images/contact.png" alt />
      <div class="bottom">
        <div class="box">
          <img class="key" src="../static/images/service.png" alt />
          <div class="value">微信扫一扫添加客服</div>
        </div>
        <div class="box">
          <img class="key" src="../static/images/WeChat-Official.png" alt />
          <div class="value">微信扫一扫关注公众号</div>
        </div>
        <div class="box">
          <img class="key" src="../static/images/Tik-Tok.png" alt />
          <div class="value">抖音扫一扫立马关注</div>
        </div>
      </div>
    </div>


		<p style="    position: relative;
    bottom: 50px;" align="center">&copy; 深圳微雨晨科技有限公司 版权所有<a href="https://beian.miit.gov.cn"> 粤ICP备2020141712号-2</a></p>		</div>


  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      checkList: ['实时绿幕抠图', 'AI抠图(无绿幕)', '自由替换背景', '应用场景广泛'],
      AndroidVal: '',
      checkVal: 0,
      updateDate:'',
      version:''
    }
  },
  created () {
    this.httpRequest()
  },
  methods: {
    handleAndroid () {
      window.location.href = this.AndroidVal
    },
    changeActive (index) {
      this.checkVal = index
    },
    httpRequest () {
      let that = this
      return new Promise((resolve, reject) => {
        axios({
          url: 'http://commonapi.kaolamobi.com/common/module/api/promotion/getH5Download?userId=847080',
          method: 'GET',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
        })
          .then(res => {
            //成功
            resolve(res.data)
            that.AndroidVal = res.data.data.downloadUrl;
            this.updateDate = res.data.data.updateDate;
            this.version = res.data.data.version;
            console.log(that.AndroidVal)
          })
          .catch(res => {
            //失败
            reject(res)
          })
      })
    },
    handleInstall () {
      document.getElementById('download').scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    handleContact () {
      document.getElementById('footer').scrollIntoView({ block: 'start', behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss">
  a{text-decoration: none;}
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .head {
    width: 100%;
    height: 787px;
    background-image: url(../static/images/head.png);
    background-size: cover;
    .logo {
      width: 160px;
      height: 35px;
      position: relative;
      top: 50px;
      left: 360px;
    }
    .introduce {
      position: relative;
      top: 146px;
      left: 360px;
      .title {
        font-size: 52px;
        font-family: HYLingXinJ;
        font-weight: 400;
        color: #ffffff;
      }
      .particulars {
        margin-top: 39px;
        width: 649px;
        height: 151px;
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .body {
    width: 100%;
    height: 2461px;
    position: relative;
    .left {
      width: 153px;
      height: 321px;
      position: absolute;
      top: -120px;
      left: 0;
    }
    .right {
      width: 178px;
      height: 321px;
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .location {
      position: fixed;
      top: 286px;
      right: 0;
      width: 86px;
      height: 86px;
      background: #8b54eb;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .install {
        width: 36px;
        height: 36px;
      }
    }
    .contact {
      position: fixed;
      top: 372px;
      right: 0;
      width: 86px;
      height: 86px;
      background: #4e75ff;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .relation {
        width: 36px;
        height: 36px;
      }
    }
    .throng {
      width: 100%;
      padding: 0 360px;
      box-sizing: border-box;
      text-align: center;
      .fit {
        width: 339px;
        height: 70px;
        margin: 87px 0 40px 0;
      }
      .row {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .items {
          width: 278px;
          height: 280px;
          background: #ffffff;
          box-shadow: 0px 10px 30px 0px rgba(45, 49, 70, 0.08);
          border-radius: 10px;
          text-align: center;
          .crowd {
            width: 278px;
            height: 220px;
          }
          .written {
            margin-top: 10px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #000000;
          }
        }
      }
    }
    .commodity {
      width: 100%;
      padding: 0 360px;
      box-sizing: border-box;
      text-align: center;
      .product {
        width: 349px;
        height: 69px;
        margin: 72px 0 40px 0;
      }
      .content {
        width: 1200px;
        height: 605px;
        display: flex;
        align-items: center;
        .content-left {
          width: 420px;
          height: 605px;
          border-radius: 10px;
          margin-right: 20px;
          cursor: pointer;
          border: 1px solid #ededed;
        }
        .content-right {
          width: 760px;
          border: 1px solid #ededed;
          border-radius: 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          .select {
            width: 286px;
            height: 605px;
            border-radius: 10px 0px 0px 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .every {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              border-bottom: 1px solid #ededed;
              font-size: 30px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #2d2d2d;
              cursor: pointer;
              box-sizing: border-box;
            }
            .active {
              background: #8b54eb;
              border-right: 1px solid #a57ee8;
              color: #ffffff;
            }
            .active:nth-child(1) {
              background: #8b54eb;
              border-right: 1px solid #a57ee8;
              border-radius: 10px 0px 0px 0px;
              color: #ffffff;
            }
            .active:nth-child(4) {
              background: #8b54eb;
              border-right: 1px solid #a57ee8;
              border-radius: 0px 0px 0px 10px;
              color: #ffffff;
            }
          }
          .option {
            width: 474px;
            height: 605px;
            .introduce {
              width: 472px;
              height: 337px;
              background: #8b54eb;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              text-align: left;
              padding: 32px 20px;
              box-sizing: border-box;
              border-radius: 0px 10px 0px 0px;
              .each {
                display: flex;
                margin-top: 31px;
              }
              .each:first-child {
                margin: 0;
              }
              .check {
                width: 20px;
                height: 20px;
                margin-right: 7px;
                margin-top: 4px;
              }
            }
            .interaction {
              width: 472px;
              height: 374px;
              background: #8b54eb;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #ffffff;
              text-align: left;
              padding: 32px 20px;
              box-sizing: border-box;
              border-radius: 0px 10px 0px 0px;
              .each {
                display: flex;
                margin-top: 31px;
              }
              .each:first-child {
                margin: 0;
              }
              .check {
                width: 20px;
                height: 20px;
                margin-right: 7px;
                margin-top: 4px;
              }
            }
            .green {
              width: 472px;
              height: 269px;
              display: block;
            }
            .range {
              width: 472px;
              height: 232px;
              display: block;
            }
          }
          .every:last-child {
            border-bottom: none;
          }
        }
      }
    }
    .superiority {
      width: 100%;
      padding: 0 360px;
      box-sizing: border-box;
      text-align: center;
      .advantage {
        width: 370px;
        height: 70px;
        margin: 72px 0 40px 0;
      }
      .row {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .items {
          width: 278px;
          height: 351px;
          background: #ffffff;
          box-shadow: 0px 10px 30px 0px rgba(45, 49, 70, 0.08);
          border-radius: 10px;
          padding: 40px 25px 34px 25px;
          box-sizing: border-box;
          .operation {
            width: 114px;
            height: 114px;
          }
          .written {
            width: 100%;
            margin-top: 19px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #000000;
          }
          .explain {
            margin-top: 10px;
            text-align: left;
            font-size: 19px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
    .download {
      width: 100%;
      padding: 0 360px;
      box-sizing: border-box;
      text-align: center;
      .img {
        width: 349px;
        height: 69px;
        margin: 72px 0 40px 0;
      }
      .box {
        width: 1200px;
        background: #ffffff;
        box-shadow: 0px 10px 30px 0px rgba(45, 49, 70, 0.08);
        border-radius: 10px;
        padding: 0 37px;
        box-sizing: border-box;
        .each {
          width: 100%;
          height: 206px;
          border-bottom: 2px dashed #e2e2e2;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .function {
            width: 360px;
            height: 110px;
            background: #a25eff;
            border-radius: 20px;
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .Android {
              width: 32px;
              height: 38px;
              margin-right: 12px;
            }
            .ios {
              width: 32px;
              height: 40px;
              margin-right: 12px;
            }
          }
          .function-ios {
            background: #6e62ff;
            text-decoration: none;
          }
          .info {
            font-size: 26px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #666666;
            text-align: right;
            .date {
              margin-bottom: 10px;
            }
          }
        }
        .each:last-child {
          border: none;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 648px;
    background-image: url(../static/images/bottom.png);
    background-size: cover;
    padding: 86px 434px;
    box-sizing: border-box;
    text-align: center;
    .contact {
      width: 401px;
      height: 73px;
    }
    .bottom {
      margin-top: 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .box {
        width: 290px;
        .key {
          width: 290px;
          height: 290px;
        }
        .value {
          margin-top: 10px;
          width: 100%;
          text-align: center;
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
